<kendo-arcgauge
  [value]="GetValue()"
  [transitions]="true"
  [scale]="GetScale()"

  style="display:block;height:250px;"
>
  <kendo-arcgauge-scale
    [majorTicks]="{ visible: true, color: ticksColor  }"
    [minorTicks]="{ visible: true, color: ticksColor }"
    [rangeSize]="10"
  >
    <kendo-arcgauge-scale-labels
      format="#.0"
      [color]="labelsColor"
      [visible]="true"
    >
    </kendo-arcgauge-scale-labels>
  </kendo-arcgauge-scale>

  <ng-template kendoArcGaugeCenterTemplate let-value="value">
    <H2> {{ GetValueStr() }} {{ GetUnit() }} </H2>
  </ng-template>

</kendo-arcgauge>
